

export enum InputAction {
  Handshake = 'Handshake',
  Downloads_All = 'Downloads_All',
  Download_Status = 'Download_Status',
  AppSettings = 'AppSettings',
}

export enum DownloadStatus {
  IDLE = 'IDLE',
  WAITING = 'WAITING',
  QUEUED = 'QUEUED',
  DOWNLOADING = 'DOWNLOADING',
  PAUSED = 'PAUSED',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  REMOVED = 'REMOVED'
}

export type DownloadStatusResponse = keyof typeof DownloadStatus

export enum DownloadQuality {
  GOOD = 'GOOD',
  BETTER = 'BETTER',
  BEST = 'BEST',
}

export type DownloadQualityResponse = keyof typeof DownloadQuality

// Handshake
export type HandshakePayload = {
  uwpRequestTime: number
}
export type HandlerHandshake = (p: HandshakePayload) => void

// GetAllDownloads
export type DownloadStatusPayload = {
  "DownloadId": string,
  "TitleId": string,
  "Status": DownloadStatusResponse,
  "ErrorCode": number,
  "Progress": number,
  "Quality": DownloadQualityResponse,
  "Size": number,
  "NeedsLicense": boolean
  "LicenseExpirationDate": number
  "LicenseExpireAfterFirstPlay": number
  "LicenseUsableForPlay": boolean
}
export type AllDownloadsPayload = {
  [titleId: string]: DownloadStatusPayload
}
export type HandlerDownloadsAll = (p: AllDownloadsPayload) => void

// GetAppSettings
export interface AppSettingsPayload {
  downloadQuality: string
  appVersion: string
  deviceId: string
  deviceName: string
  downloadOnMobileData: boolean
  freeSpace: number
  capacitySpace: number
  usedSpace: number
  canSendFeedback: boolean
}

export type HandlerGetAppSettings = (p: AppSettingsPayload) => void


// DownloadStatus
export type HandlerDownloadStatus = (p: DownloadStatusPayload) => void

export type InputHandlers =
  | HandlerHandshake
  | HandlerDownloadsAll
  | HandlerDownloadStatus
  | HandlerGetAppSettings

export type InputActions = keyof typeof InputAction
